import { DestroyRef, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TokenStorageService } from './token-storage.service';
import { AuthService } from './auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

export const authGuard: CanActivateFn = () => {
  const tokenService = inject(TokenStorageService);
  const authService = inject(AuthService);
  const destroyRef = inject(DestroyRef);
  const router = inject(Router);

  if (authService.isTokenValid(tokenService.getToken())) {
    return true;
  }

  authService.logout().pipe(takeUntilDestroyed(destroyRef)).subscribe();
  return router.createUrlTree(['/login']);
};
